import React from 'react'
import './Slogan.css';
import Carousel from 'react-bootstrap/Carousel'


const Slogan = () => {
    return (
        <div className='slogans'>
            <Carousel controls={false} fade interval={6000}>
                <Carousel.Item>
                    <div className='font'>
                        <p>Maakt het</p>
                        <p>Onzichtbare</p>
                        <p>Zichtbaar</p>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='font'>
                        <p>Ontraadselt</p>
                        <p>Complexe</p>
                        <p>Vraagstukken</p>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='font'>
                        <p>Beweegt</p>
                        <p>Van Ego</p>
                        <p>Naar Eco</p>
                    </div>
                </Carousel.Item>
            </Carousel>
        </div>
    )
}


export default Slogan;